import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import PropTypes from "prop-types";

const LinearProgressWithLabel = (props) => {
  const { value, showValue } = props;
  return (
    <Box display="flex" justifyContent="center" ml={6} mb={4}>
      <Box width="50%" mr={1} ml={2}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        {showValue && (
          <Typography variant="body2" color="textSecondary">{`${Math.round(
            value
          )}%`}</Typography>
        )}
      </Box>
    </Box>
  );
};

LinearProgressWithLabel.defaultProps = {
  value: 0,
  showValue: true,
};

LinearProgressWithLabel.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showValue: PropTypes.bool,
};

export default LinearProgressWithLabel;
